import ElectronIPC from './ElectronIPC'

type ExceptionTestType =
    | 'TEST_MAIN_EXCEPTION'
    | 'TEST_MAIN_UNHANDLED_REJECTION'
    | 'TEST_CRASH'
    | 'causeException'
    | 'causeUnhandledRejection'

export function exceptionTest(t: ExceptionTestType) {
    if (t === 'TEST_MAIN_EXCEPTION') {
        ElectronIPC.exceptionTest('TEST_MAIN_EXCEPTION')
    } else if (t === 'TEST_MAIN_UNHANDLED_REJECTION') {
        ElectronIPC.exceptionTest('TEST_MAIN_UNHANDLED_REJECTION')
    } else if (t === 'TEST_CRASH') {
        ElectronIPC.exceptionTest('TEST_CRASH')
    } else if (t === 'causeException') {
        const a = undefined
        // @ts-ignore
        a.causeException = true
    } else if (t === 'causeUnhandledRejection') {
        causeUnhandledRejection()
    }
}

function causeUnhandledRejection() {
    function promise() {
        return new Promise((resolve, _) => {
            setTimeout(() => {
                // @ts-ignore
                return resolve()
            }, 100)
        })
    }

    promise().then(() => {
        const a = undefined
        // @ts-ignore
        a.causeUnhandledRejection = true
    })
}
